{
  "navigationRoutes": {
    "home": "Accueil"
  },
  "menu": {
    "auth": "Authentification",
    "buttons": "Boutons",
    "timelines": "Frises chronologiques",
    "dashboard": "Tableau de bord",
    "billing": "Facturation",
    "login": "Connexion",
    "preferences": "Préférences du compte",
    "payments": "Gestion des paiements",
    "settings": "Paramètres",
    "pricing-plans": "Plans tarifaires",
    "payment-methods": "Moyens de paiement",
    "signup": "Inscription",
    "recover-password": "Mot de passe oublié",
    "recover-password-email": "Email de récupération",
    "404": "404",
    "faq": "FAQ",
    "users": "Utilisateurs",
    "projects": "Projets",
    "general-report": "Rapport général",
    "clients": "Gestion des clients",
    "create-client": "Créer un client",
    "list-clients": "Liste des clients",
    "archived-clients": "Clients archivés",
    "missions": "Gestion des missions",
    "create-diligence": "Créer Diligence",
    "diligence-history": "Historique diligence",
    "create-attestation": "Créer une attestation",
    "create-mission": "Créer une mission",
    "attestation-history": "Historique des attestations",
    "mission-history": "Historique des missions",
    "cancel-attestation": "Annuler une attestation",
    "documents": "Gestion des documents",
    "add-document": "Ajouter un document",
    "list-documents": "Liste des documents",
    "initiate-payment": "Initier un paiement",
    "perform-payment": "Effectuer un paiement",
    "payment-history": "Historique des paiements",
    "minipay": "MiniPay",
    "transfer-journal": "Journal de transfert",
    "stickers": "Gestion des vignettes",
    "enter-sticker": "Entré sticker",
    "exit-sticker": "Sorti sticker",
    "stock-sticker": "Stock sticker",
    "expenses": "Gestion des dépenses",
    "receivables": "Gestion des créances",
    "receivables-list": "Créances",
    "non-invoiced": "Non facturé",
    "contributors": "Gestion des apporteurs",
    "add-contributor": "Ajouter un apporteur",
    "list-contributors": "Liste des apporteurs",
    "pay-commission": "Payer la commission",
    "settle-commission": "Régler la commission",
    "commission-history": "Historique des commissions",
    "statistics": "Rapports & Statistiques",
    "client-report": "Rapport client",
    "attestation-report": "Rapport attestation",
    "mission-report": "Rapport mission",
    "finance-report": "Rapport financier",
    "annual-client-report": "Rapport client annuel",
    "fiscal-report": "Rapport fiscal",
    "general-settings": "Paramètre général",
    "other": "Autre",
    "appointments": "Rendez-vous",
    "notes": "Notes",
    "permission-request": "Demande d'autorisation",
    "manage-permissions": "Gérer les autorisations",
    "communications": "Communications",
    "company": "Entreprise",
    "banks": "Banques",
    "chatbox": "Boîte de chat",
    "mailbox": "Messagerie",
    "chatbox-settings": "Paramètres ChatBox",
    "mailbox-settings": "Paramètres Messagerie",
    "fiscal-regime": "Régime fiscal",
    "attestation-types": "Types d'attestation",
    "mission-types": "Types de mission",
    "report-types": "Types de rapport",
    "report-types-bilan": "Types de bilan",
    "expense-types": "Types de dépense",
    "permission-types": "Types d'autorisation",
    "objectives": "Objectifs"
  },
  "language": {
    "brazilian_portuguese": "Portugais brésilien",
    "english": "Anglais",
    "spanish": "Espagnol",
    "simplified_chinese": "Chinois simplifié",
    "persian": "Persan"
  }
}
